export default {"src":"/_next/static/media/error-circle.a2ff8c08.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};